import type { WarehouseRequestType } from './WarehouseApi';
import { defaultWarehouse } from './defaultWarehouse';
import { WarehouseRequestSchema } from './WarehouseApi';

export class Warehouse {
    private readonly _innerId: string;
    private _id: number | null = null;
    private _warehouseData: WarehouseRequestType | null = null;

    constructor() {
        this._innerId = Math.random().toString(36);
    }

    public get innerId(): string {
        return this._innerId;
    }

    public get warehouseData(): WarehouseRequestType | null {
        return this._warehouseData;
    }

    public get() {
        return this._warehouseData;
    }

    public set(data: WarehouseRequestType, id: number | null): this {
        this._id = id;
        this._warehouseData = WarehouseRequestSchema.parse(data);
        return this;
    }

    public getId() {
        return this._id;
    }

    public isNew() {
        return this._id === null;
    }

    public getX(): number | null {
        return this._warehouseData?.geom.coordinates[0] || null;
    }

    public getY(): number | null  {
        return this._warehouseData?.geom.coordinates[1] || null;
    }

    public getName() {
        return this._warehouseData?.name || '';
    }

    public getAddress() {
        return this._warehouseData?.details.query || '';
    }

    public setName(name: string) {
        this._warehouseData = {
            ...(this._warehouseData ?? defaultWarehouse),
            name,
        };
        return this;
    }

    public getAbbreviation() {
        return this._warehouseData?.details.abbreviation || '';
    }

    public setAbbreviation(abbreviation: string) {
        this._warehouseData = {
            ...(this._warehouseData ?? defaultWarehouse),
            details: {
                ...(this._warehouseData?.details ?? {
                    query: '',
                    city: '',
                    street: '',
                    abbreviation: '',
                    house: '',
                }),
                abbreviation,
            },
        };
        return this;
    }

    public getCity() {
        return this._warehouseData?.details.city || '';
    }

    public getStreet() {
        return this._warehouseData?.details.street || '';
    }

    public getHouse() {
        return this._warehouseData?.details.house || '';
    }

    public getDetails() {
        return this._warehouseData?.details || {};
    }

    public calcAbbreviation(warehouses: Warehouse[] = []): string {
        // Bemowo -> Be
        // New York -> NY
        // Magazyn Tarnowo Podgórne -> TP
        let abbreviations: string[] = warehouses.filter((w) => w !== this).map((w) => w.getAbbreviation());
        let abbr = '';
        let name = this.getName().trim();
        if (name) {
            if (name.split(/\s+/).length > 1) {
                abbr = name
                    .split(/\s+/)
                    .map((w, idx, a) =>
                        !w.match(/magazyn/i) || a.length == 1 ? w[0].toUpperCase() : ''
                    )
                    .join('');
            } else {
                abbr = name[0].toUpperCase() + (name[1] ? name[1] : '');
            }

            if (abbr.length > 2) {
                abbr = abbr.slice(0, 2);
            }

            let uniqabbr = abbr;
            let number = 1;
            while (abbreviations.indexOf(uniqabbr) >= 0) {
                uniqabbr = abbr+number.toString();
                number++;
            }
            abbr = uniqabbr;

            // if last letter is a number, add it to abbreviation
            // if (/\d/.test(name[name.length - 1])) {
            //     abbr += name[name.length - 1];
            // }
        }
        this.setAbbreviation(abbr);
        return abbr;
    }
}
